var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lengend", class: _vm.pz }, [
    _c("div", { staticClass: "flex-around topNav" }, [
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "flex warn-table" }, [
          _c(
            "div",
            {
              staticClass: "flex",
              class: _vm.curname === "人员指数" ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.updcur("人员指数")
                },
              },
            },
            [
              _vm._m(0),
              _c("div", { staticClass: "item-val-box" }, [
                _c("div", { staticClass: "item-val" }, [
                  _vm._v(" " + _vm._s(_vm.ry)),
                  _c("img", {
                    staticClass: "jt-img",
                    attrs: { src: _vm.ryImg, alt: "" },
                  }),
                ]),
                _c("div", [_vm._v("人员指数")]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex",
              class: _vm.curname === "车辆指数" ? "active" : "",
              on: {
                click: function ($event) {
                  return _vm.updcur("车辆指数")
                },
              },
            },
            [
              _vm._m(1),
              _c("div", { staticClass: "item-val-box" }, [
                _c("div", { staticClass: "item-val" }, [
                  _vm._v(" " + _vm._s(_vm.cl) + " "),
                  _c("img", {
                    staticClass: "jt-img",
                    attrs: { src: _vm.clImg, alt: "" },
                  }),
                ]),
                _c("div", [_vm._v("车辆指数")]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgs flex" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/schj/ico_ry.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "imgs flex" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/schj/ico_cl.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }